import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import LinkCell, { LinkCellType } from "./LinkCell";
import Utils from "../../utils/Utils";
export default class LinkReel {
    constructor(scene, x, y, index, orientation) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 300;
        this.suspenseDuration = 600;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        /** Cells of the reel */
        this.linkCells = [];
        this.t0 = 0;
        this.preStopMs = 2200; // tempo “attivo” prima del bounce (fisso!)
        this.spinMainButtonTween = null;
        this.isButtonSpinning = false;
        this.baseSpeed = 1.9; // velocità base
        this.speedJitter = 0.08; // piccola variazione
        this.delayPerReel = 120; // ms di ritardo per indice
        this.extraDelayJitter = 50; // jitter per non farli allineare
        this.scene = scene;
        this.gameLogicVariableManager = window.GameLogicVariableManager;
        this.gameDataManager = window.GameDataManager;
        this.index = index;
        this.orientation = orientation;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.numOfLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL;
        this.numOfExtraLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_LINK_CELLS_PER_REEL;
        this.linkCellsPosition = ResourcesDispatcher.GAME_CONSTANTS.linkCellsPosition;
        this.linkReelsPosition = ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition;
        this.lastLinkCellIndex = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL + this.numOfExtraLinkCellsPerReel - 1;
        this.container = this.scene.add.container(x, y);
        this.createReelMask(orientation);
        this.startDelayMs = index * this.delayPerReel + Phaser.Math.Between(0, this.extraDelayJitter);
        this.spinSpeed = this.baseSpeed + index * 0.12 + Phaser.Math.FloatBetween(-this.speedJitter, this.speedJitter);
        this.phaseOffsetPx = Math.round((index * (this.cellSize.height / ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS)) % this.cellSize.height);
        this.fixedLinkCell = new LinkCell(this.scene, this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, 1, this, LinkCellType.FIXED);
        this.animationsContainer = this.scene.add.container(x, y);
        this.animationsContainer.add(this.fixedLinkCell.getContainer());
        this.animationsContainer.setVisible(false);
        this.linkSuspenseRaw = ResourcesDispatcher.SPINES.Reel_Suspense_Link;
        this.linkSuspense = this.scene.add.spine(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, this.linkSuspenseRaw.jsonKey, this.linkSuspenseRaw.atlasKey).setOrigin(0.5).setVisible(false);
        this.linkSuspenseReelRaw = ResourcesDispatcher.SPINES.Reel_Suspense_Link_Rullo;
        this.linkSuspenseReel = this.scene.add.spine(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, this.linkSuspenseReelRaw.jsonKey, this.linkSuspenseReelRaw.atlasKey).setOrigin(0.5).setVisible(false);
        this.frame = this.scene.add.image(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, ResourcesDispatcher.ATLAS.LINKREEL_FRAME.key, ResourcesDispatcher.ATLAS.LINKREEL_FRAME.frameKey).setOrigin(0.5, 0.5);
        this.frameContainer = this.scene.add.container(x, y);
        this.frameContainer.add([this.frame, this.linkSuspense, this.linkSuspenseReel]);
    }
    createReelMask(orientation) {
        // se esiste già una graphics/mask precedente la distruggiamo e rimuoviamo la mask dal container
        if (this.linkReelMask) {
            this.linkReelMask.destroy();
            this.container.clearMask(true);
            this.linkReelMask = undefined;
        }
        const visibleHeight = this.cellSize.height;
        const currentOrientation = orientation;
        let xContainer = 0;
        let yContainer = 0;
        let scale = 0;
        if (currentOrientation == "portrait") {
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_LINK_X; //155
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_LINK_Y; //796
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_LINK_SCALE;
        }
        else {
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_LINK_X; //525
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_LINK_Y; //280
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_LINK_SCALE;
        }
        // crea la graphics che useremo per la mask (la aggiungiamo alla scena per poterla gestire/distruggere facilmente)
        this.linkReelMask = this.scene.make.graphics({ x: 0, y: 0, add: false });
        this.linkReelMask.fillRect(xContainer, yContainer, ResourcesDispatcher.GAME_CONSTANTS.LINK_SPIN_REEL_STATIC_MASK_WIDTHS[this.index], visibleHeight).setScale(scale);
        // Serve per mostrare la maschera della griglia per debuggare
        // const debugGraphics = this.scene.add.graphics();
        // debugGraphics.lineStyle(2, 0xff0000, 0.5); // spessore 2px, rosso
        // this.linkCells.forEach((cell) => {
        //     const c = cell.getContainer(); // container grafico della cella
        //     const width = this.cellSize.width;
        //     const height = visibleHeight;
        //     debugGraphics.strokeRect(xContainer, yContainer, width, height).setScale(scale);
        // });
        // // crea la maschera
        this.container.setMask(new Phaser.Display.Masks.GeometryMask(this.scene, this.linkReelMask));
    }
    setIndex(value) {
        this.index = value;
    }
    getIndex() {
        return this.index;
    }
    getContainer() {
        return this.container;
    }
    getFrameContainer() {
        return this.frameContainer;
    }
    getAnimationsContainer() {
        return this.animationsContainer;
    }
    resetFlagsAndCounters() {
        this.virtualReelPosition = Utils.getRandomInt(0, this.scene.linkGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.canStop = false;
        this.stopped = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
    resetCellsPositions() {
        this.linkCells.forEach((linkCell, index) => {
            linkCell.getContainer().y = this.linkCellsPosition[index].y;
        });
    }
    reIndexCells() {
        let linkCells = [];
        for (let i = 1; i < this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel; i++) {
            linkCells[i - 1] = this.linkCells[i];
            this.linkCells[i].setIndex(i - 1);
        }
        this.linkCells[0].setIndex(this.lastLinkCellIndex);
        linkCells[this.lastLinkCellIndex] = this.linkCells[0];
        this.linkCells = [];
        this.linkCells = linkCells;
    }
    get stepMs() { return this.spinAnimationDuration / this.spinSpeed; }
    configureSpinTween() {
        this.resetFlagsAndCounters();
    }
    //Chiamato dal gioco per far partire il giro del rullo
    spin(mainButtonBackground) {
        this.spinProgress.play();
        if (mainButtonBackground) {
            if (window.isButtonSpinning === false) {
                window.isButtonSpinning = true;
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground, this.scene);
            }
        }
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }
    reset() {
        // this.fixedLinkCell.getContainer().setVisible(false).setAlpha(1);
        // this.fixedLinkCell.setMemo(0);
        // this.fixedLinkCell.multValue = -1;
        this.fixedLinkCell.disableLinkCell();
        this.container.setVisible(true);
        this.animationsContainer.setVisible(false);
        // this.fixedLinkCell.getLinkSpineValueText().setVisible(false);
        // this.fixedLinkCell.getLinkSpineWithValue().setVisible(false);
        // this.fixedLinkCell.getLinkSpineWithText().setVisible(false).setAlpha(1);
    }
    enableSuspenseState() {
        return new Promise((resolve) => {
            const animations = this.linkSuspenseRaw.animations;
            if (animations) {
                const trackEntry = this.linkSuspense.animationState.addAnimation(0, animations[0], true);
                trackEntry.alpha = 1;
                this.linkSuspense.setVisible(true);
            }
            resolve(true);
        });
    }
    disableSuspenseState() {
        this.linkSuspense.setVisible(false);
    }
    enableSuspenseReelState(animation) {
        return new Promise((resolve) => {
            const animations = this.linkSuspenseReelRaw.animations;
            if (animations) {
                const trackEntry = this.linkSuspenseReel.animationState.addAnimation(0, animation, true);
                trackEntry.alpha = 1;
                this.linkSuspenseReel.setVisible(true);
            }
            resolve(true);
        });
    }
    disableSuspenseReelState() {
        this.linkSuspenseReel.setVisible(false);
    }
}
